import { createFileRoute } from "@tanstack/react-router";
import WorkflowsPage from "@/features/workflows/WorkflowsPage";
import { requireFeatureEnabled } from "@/features/features";

export const Route = createFileRoute("/_admin/workflows/")({
  beforeLoad: () => requireFeatureEnabled("workflows"),
  component: WorkflowsPage,
});
